module.exports = {"id":"","name":"","font_family":"iconfont","css_prefix_text":"icon-","description":"","glyphs":[{"icon_id":"947480","name":"密码","font_class":"mima","unicode":"e646","unicode_decimal":58950},{"icon_id":"2559431","name":"用户","font_class":"yonghu","unicode":"e6b3","unicode_decimal":59059}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.json
// module id = S5XW
// module chunks = 1